var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// $FlowFixMe
import { ModalConfirmForm } from 'app/components/Modal';
import { FormData } from 'app/components/Form';
import { useDispatch } from 'react-redux';
import { createCollectiveAgreementTitle, updateCollectiveAgreementTitle, } from 'app/store/reducers/collectiveAgreementTitles';
export function ModalEditCollectiveAgreementTitle(props) {
    const { collectiveAgreementTitle, onSave, onChange } = props, modalProps = __rest(props, ["collectiveAgreementTitle", "onSave", "onChange"]);
    const dispatch = useDispatch();
    function save(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const newCollectiveAgreementTitle = Object.assign(Object.assign({}, collectiveAgreementTitle), data);
            if (onSave)
                return onSave(newCollectiveAgreementTitle);
            const res = yield dispatch((newCollectiveAgreementTitle === null || newCollectiveAgreementTitle === void 0 ? void 0 : newCollectiveAgreementTitle.id)
                ? updateCollectiveAgreementTitle(newCollectiveAgreementTitle)
                : createCollectiveAgreementTitle(newCollectiveAgreementTitle));
            return res;
        });
    }
    return (_jsx(ModalConfirmForm, Object.assign({ title: collectiveAgreementTitle ? `Edit collective agreement title` : 'Create new collective agreement title', draggable: true }, modalProps, { children: _jsx(FormData, { onSave: onSave || save, flashNotifSuccessLabel: `Collective agreement title ${collectiveAgreementTitle ? 'edited' : 'created'}`, defaultData: collectiveAgreementTitle, properties: [
                {
                    label: 'Title',
                    key: 'jobTitle',
                    type: 'string',
                    elementProps: {
                        isRequired: true,
                    },
                },
                {
                    label: 'Minimum salary',
                    key: 'minimumSalary',
                    type: 'string',
                    elementProps: {
                        type: 'number',
                        isRequired: true,
                    },
                },
                {
                    label: 'Minimum salary 35h',
                    key: 'secondMinimumSalary',
                    type: 'string',
                    elementProps: {
                        type: 'number',
                        isRequired: false,
                    },
                },
                {
                    label: 'Managerial',
                    key: 'managerial',
                    type: 'checkbox',
                },
                {
                    label: 'Field',
                    key: 'field',
                    type: 'string',
                },
                {
                    label: 'Sector',
                    key: 'sector',
                    type: 'string',
                },
                {
                    label: 'Level',
                    key: 'level',
                    type: 'string',
                },
                {
                    label: 'Mission',
                    key: 'mission',
                    type: 'textarea',
                    elementProps: {
                        style: { width: '100%' },
                    },
                },
            ] }) })));
}
